import { render, staticRenderFns } from "./SubNavBar.vue?vue&type=template&id=1fba31ee&"
import script from "./SubNavBar.vue?vue&type=script&lang=js&"
export * from "./SubNavBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports